import "react";
import { ColorCircle } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/calendar/ServicePeriodCalendarSummary.tsx
function Count({ count, label, variant }) {
	if (count === 0) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-xxs flex items-center",
		children: [/* @__PURE__ */ jsx(ColorCircle, {
			size: "sm",
			variant
		}), /* @__PURE__ */ jsxs("span", {
			className: "text-color-subtle text-sm",
			children: [
				count,
				" ",
				label
			]
		})]
	});
}
function ServicePeriodCalendarSummary({ fulfilled, missed, partial, total }) {
	if (total === 0) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-sm flex flex-wrap items-center",
		children: [
			/* @__PURE__ */ jsxs("span", {
				className: "text-color-strong text-sm font-medium",
				children: [
					total,
					" ",
					total === 1 ? "period" : "periods"
				]
			}),
			/* @__PURE__ */ jsx(Count, {
				count: fulfilled,
				label: "fulfilled",
				variant: "positive"
			}),
			/* @__PURE__ */ jsx(Count, {
				count: partial,
				label: "partial",
				variant: "caution"
			}),
			/* @__PURE__ */ jsx(Count, {
				count: missed,
				label: "missed",
				variant: "critical"
			})
		]
	});
}
//#endregion
export { ServicePeriodCalendarSummary };

//# sourceMappingURL=ServicePeriodCalendarSummary.js.map